<template>
  <div class="activity-detail" ref="activityDetail" v-loading.fullscreen.lock="loading">
    <div v-if="noData =='false'" style="height:440px;overflow:auto;">
      <!-- <div class="sino-welfare-title" title="activityDeailStaff.name">{{activityDeailStaff.name}}</div> -->
      <!-- 头部信息 -->
      <activityHeader :textList="textList" :textObj="textObj" />

      <div class="sino-welfare-content">
        <!-- <div
        v-html="activityDeailStaff.content"
        class="html"
        ref="fold"
        :style="{maxHeight:this.foldHeight?this.foldHeight+'px':'',overflowY:this.foldHeight?'scroll':''}"
      ></div>
      <span class="sino-fold-btn" v-if="foldBtn" @click="toggleFlod">
        {{fold?'收起':"展开"}}
        <span
          :class="['iconfont', fold?'iconfenhui-gonghuihuodongbuxubaomingzhuanhuan-6':'iconfenhui-gonghuihuodongbuxubaomingzhuanhuan-7']"
        ></span>
        </span>-->

        <div v-if="!role||(role=='union'&& radio == '2')">
          <div
            class="sino-prize sino-prize-my"
            v-for="item in activityDeailStaff.prizesList"
            :key="item.awardsTempId"
          >
            <div>恭喜你</div>
            <div>
              获得了
              <span>{{item.awardsTempName}}</span>
            </div>
          </div>
        </div>
        <div v-else>
          <div
            v-for="item in activityDeailStaff.prizesList"
            :key="item.awardsTempId"
            class="sino-prize"
          >
            <div class="prize-lev prize-lev-flex">
              <div class="text-max-width">{{item.awardsTempName}}</div>
              <span style="color:#38C7C4;margin:0 4px">{{item.staffSum}}</span> 人
              <span class="check-btn" @click="openWinners(item)">
                {{item.openText}}
                <i
                  :class="['iconfont',item.openText == '展开'?'iconfenhui-gonghuihuodongbuxubaomingzhuanhuan-7':'iconfenhui-gonghuihuodongbuxubaomingzhuanhuan-6']"
                ></i>
              </span>
            </div>
            <div
              v-if="item.awardStaffName"
              class="winners"
              v-show="item.openText == '收起'"
            >{{item.awardStaffName.split(",").join("、")}}</div>
          </div>
        </div>
      </div>

      <div class="sino-activity-footer" v-if="$route.query.source != 'me'">
        <div class="sign" v-if="!normal&&(roleCode == '3' || roleCode=='2')">
          <div class="radio-block" v-if="unionBranchAwardFlag">
            <el-radio v-model="radio" label="1" @change="handleRadioChange('1')">确认签名</el-radio>
            <el-radio v-model="radio" label="2" @change="handleRadioChange('2')">我的签名</el-radio>
          </div>

          <div v-if="this.radio=='1'">
            <div class="img-block">
              <img v-if="signaImg!='zhuxi'&& signaImg" class="sign-img" :src="signaImg" alt srcset />
            </div>
            <div v-if="activityDeailStaff.signature" class="save-btn-disabled">已签名</div>

             <div
              v-else
              :class="[signaImg == 'zhuxi' && (activityStatus==1 ||activityStatus==2)? 'save-btn':'save-btn-disabled']"
              @click="showPopup('myPopup')"
            >确认并签名</div>
          </div>

          <div v-if="this.radio=='2'">
            <div class="img-block">
              <img v-if="branchAdminSignImg" class="sign-img" :src="branchAdminSignImg" alt srcset />
            </div>
            <div v-if="branchAdminSignImg" class="save-btn-disabled">已签名</div>
            <div
              v-else
              :class="[!branchAdminSignImg &&  (activityStatus==1 ||activityStatus==2)? 'save-btn':'save-btn-disabled']"
              @click="showPopup('hy')"
            >确认领取并签名</div>
          </div>
        </div>
        <!-- 员工签名 -->
        <div class="sign" v-if="normal">
          <div>
            <div class="img-block">
              <img
                v-if="activityDeailStaff.prizesSignature"
                class="sign-img"
                :src="signaImg"
                alt
                srcset
              />
            </div>
            <div v-if="activityDeailStaff.prizesSignature" class="save-btn-disabled">已签名</div>
            <div
              v-else
              :class="[activityDeailStaff.signature && (activityStatus==1 || activityStatus==2) && signaImg == ''? 'save-btn':'save-btn-disabled']"
              @click="showPopup('hy')"
            >确认领取并签名</div>
          </div>
        </div>
      </div>
      <div v-show="showSig" style="position:fixed;top:0" v-loading="loading">
        <signature @closePop="closePop" @saveImg="upload"></signature>
      </div>
    </div>
    <page-none v-if="noData =='true'" />
  </div>
</template>

<script type="text/ecmascript-6">
import {
  getActivityPrizesForStaff, //获取职工的获奖内容详情（roleCode为空时，调用此接口）
  getActivityPrizesForUnion,
  signupHonoreeSignature,
  unionBranchAdminSignature
} from "@/common/api";
import { toast } from "@/common/api/api.js";
import signature from "../../components/signature.vue";
import moment from "moment";
import activityConfig from "../../centralControl/utils/activityConfig";
import activityHeader from "../../view/activity/component/activityHeader";
import pageNone from "../../components/pageNone";
export default {
  data() {
    return {
      roleCode: JSON.parse(localStorage.getItem("loginInfo")).identity,
      status: "0",
      btnLabel: "确认领取并签名",
      signupRecordId: "",
      activityDeailStaff: {},
      loading: false,
      prizesSignature: "",
      role: "",
      isSigna: true,
      showSig: false,
      isReceive: false,
      signaImg: "",
      signature: "",
      currentBaseInfo: JSON.parse(localStorage.getItem("loginInfo")),
      foldBtn: true,
      foldHeight: 160,
      fold: false,

      branchAdminSignImg: "", // 工会主席自己领取福利的签名
      radio: "1",
      awardStaffList: [], // 获奖人员名单
      unionBranchAwardFlag: false, // 工会主席是否自己也有奖品

      normal: "", // 如果是确认normal为false,给自己领取,normal为true
      textList: [],
      textObj: [],
      noData: "",
      activityStatus:'',//活动奖品状态
      category:''
    };
  },
  created() {
    this.getRole();
    this.activityStatus = this.$route.query.status;
    this.category = this.$route.query.welfareCategory;
    //  0:'未开始',1:'进行中',2:'已结束',
    // this.unionBranchAwardFlag=true;
  },
  mounted() {
    this.$refs.activityDetail.scrollTop = 0;
  },
  components: {
    signature,
    activityHeader,
    pageNone
  },
  methods: {
    getRole() {
      let level = this.$route.query.level;
      let status = this.$route.query.status; // 获取上级是否已经进行签名
      /**
       * 1.工会，系管创建的活动，分会主席进行领奖确认
       * 2.分会主席创建的活动，分会组长进行领奖确认
       */
      if (
        (this.currentBaseInfo.identity == "3" && level == 1) ||
        (this.currentBaseInfo.identity == "2" && level == 2)
      ) {
        this.role = "union";
        this.getActivityUnion();
        this.normal = false;
      } else {
        this.getActivityStaff();
        this.normal = true;
      }
    },

    // 判断分会主席是否自己也有奖品
    checkAward() {
      let awardStaffId = [];
      let userId = JSON.parse(localStorage.getItem("loginInfo")).id;
      this.awardStaffList.forEach(item => {
        awardStaffId.push(...item.awardStaffId.split(","));
      });
      for (let i = 0; i < awardStaffId.length; i++) {
        if (awardStaffId[i] == userId && this.status == 0) {
          this.unionBranchAwardFlag = true;
        }
      }
    },

    // 分会主席也中奖的进行签名切换
    handleRadioChange(val) {
      this.radio = val;
      this.foldHeight = 160;
      this.foldBtn = true;
      this.fold = false;
      if (this.radio == "2") {
        this.getActivityStaff();
      } else {
        this.getActivityUnion();
      }
    },

    // v-html展开收起功能
    handleVhtml() {
      // this.$nextTick(() => {
      //   let actualheight=this.$refs.fold.offsetHeight;
      //   let scrollHeight=this.$refs.fold.scrollHeight;
      //   if(scrollHeight <= actualheight){
      //       this.foldBtn=false;
      //   }
      // })
    },

    getActivityStaff() {  //职工获奖内容详情
      this.loading = true;
      getActivityPrizesForStaff({
        activityId: this.$route.query.activityId,
        staffId: this.currentBaseInfo.id
      }).then(res => {
        if (res.code == 200) {
          this.noData = "false";
          this.loading = false;
          res.data.content = res.data.content
            .replace(new RegExp("&lt;", "g"), "<")
            .replace(new RegExp("&quot;", "g"), "")
            .replace(new RegExp("&gt;", "g"), ">");
          this.activityDeailStaff = res.data;
          this.status = res.data.status;

          // 新的头部
          let {
            startTime,
            endTime,
            creatorOfficeLevel,
            name,
            status,
            content,
            type,
            template
          } = res.data;
          // 起止时间
          startTime =
            startTime && startTime.split(" ") && startTime.split(" ")[0];
          endTime = endTime && endTime.split(" ") && endTime.split(" ")[0];
          let during = startTime + " 至 " + endTime;
          // 主办单位
          let levelObj = {
            1: "工会",
            2: "分会"
          };
          // 头部信息
          this.textList = [
            { label: "主办单位", value: levelObj[creatorOfficeLevel] },
            { label: "活动时间", value: during },
            {
              label: "活动类型",
              value: activityConfig.typeObj[type],
              color: "#29BEBC"
            }
          ];
          if (template && template.name){
            this.textList.push({ label: "活动模板", value: template.name });
          }
          this.textObj = {
            title: name,
            status: this.$route.query.status,
            statusName: activityConfig.statueObj[this.$route.query.status],
            content: content
          };

          // 分会主席如果有奖品，签名就是确认签名
          if (this.role == "union" && this.unionBranchAwardFlag) {
            this.branchAdminSignImg = res.data.prizesSignature;
          } else {
            this.signaImg = res.data.prizesSignature;
          }

          this.awardStaffList = res.data.prizesList;

          this.signupRecordId = res.data.prizesList[0].signupRecordId;
          let startTime1 = moment(res.data.startTime);
          let endTime1 = moment(res.data.endTime);
          let currentTime = moment();
          if (startTime1 < currentTime && endTime1 > currentTime) {
            this.isReceive = true;
          }
          this.handleVhtml();
        } else {
           this.noData = "true";
          this.loading = false;
          toast(this, res.message, "error");
          // setTimeout(() => {
          //   this.$router.go(-1);
          // }, 1000);
        }
      });
    },

    toggleFlod() {
      this.foldHeight = "";
      this.$refs.fold.scrollTop = 0;
      this.fold = !this.fold;
      if (!this.fold) {
        this.$refs.fold.scrollTop = 0;
        this.foldHeight = 160;
      }
    },

    getActivityUnion() {
      this.loading = true;
      getActivityPrizesForUnion({
        activityId: this.$route.query.activityId,
        unionId: this.currentBaseInfo.unionId
      }).then(res => {
        if (res.code == 200) {
          this.noData = "false";
          res.data.content = res.data.content
            .replace(new RegExp("&lt;", "g"), "<")
            .replace(new RegExp("&quot;", "g"), "")
            .replace(new RegExp("&gt;", "g"), ">");
          // 新的头部
          let {
            startTime,
            endTime,
            creatorOfficeLevel,
            name,
            status,
            content,
            type,
            template
          } = res.data;
          // 起止时间
          startTime =
            startTime && startTime.split(" ") && startTime.split(" ")[0];
          endTime = endTime && endTime.split(" ") && endTime.split(" ")[0];
          let during = startTime + " 至 " + endTime;
          // 主办单位
          let levelObj = {
            1: "工会",
            2: "分会"
          };
          // 头部信息
          this.textList = [
            { label: "主办单位", value: levelObj[creatorOfficeLevel] },
            { label: "活动时间", value: during },
            {
              label: "活动类型",
              value: activityConfig.typeObj[type],
              color: "#29BEBC"
            }
          ];
          if (template && template.name)
            this.textList.push({ label: "活动模板", value: template.name });
          this.textObj = {
            title: name,
            status: this.$route.query.status,
            statusName: activityConfig.statueObj[this.$route.query.status],
            content: content
          };
          this.activityDeailStaff = res.data;

          this.awardStaffList = res.data.prizesList;
          this.checkAward();

          this.signupRecordId =
            res.data.prizesList[0] && res.data.prizesList[0].signupRecordId;
          this.activityDeailStaff.prizesList.forEach(item => {
            item.openText = "展开";
          });
          let startTimeBefore = moment(res.data.startTime);
          let endTimeBefore = moment(res.data.endTime);
          let currentTime = moment();
          if (startTimeBefore < currentTime && endTimeBefore > currentTime) {
            this.isReceive = true;
          }

          this.status = res.data.status;

          if (res.data.signature == "") {
            this.signaImg = "zhuxi";
          } else {
            this.signaImg = res.data.signature;
          }
          this.handleVhtml();
          this.loading = false;
        } else {
          this.noData = "true";
          this.loading = false;
          toast(this, res.message, "error");
          // setTimeout(() => {
          //   this.$router.go(-1);
          // }, 1000);
        }
      });
    },

    showPopup(type) {
      if (type == "hy") {
        if (
          this.activityDeailStaff.signature &&
          (this.activityStatus==1 ||this.activityStatus==2) &&
          this.signaImg == ""
        ) {
          this.showSig = true;
        }

        if (
           (this.activityStatus==1 ||this.activityStatus==2) &&
          this.unionBranchAwardFlag &&
          !this.branchAdminSignImg
        ) {
          this.showSig = true;
        }
      } else {
        if (this.signaImg != "zhuxi") {
          return;
        } else {
          this.showSig = true;
        }
      }
    },

    closePop() {
      this.showSig = false;
    },
    upload(data) {
      if (!data) {
        toast(this, "请完成签名后领取", "error");
      } else {
        this.loading = true;
        if (
          this.role == "" ||
          (this.role == "union" &&
            this.unionBranchAwardFlag &&
            this.status == "1")
        ) {
          signupHonoreeSignature({
            activityId: this.$route.query.activityId,
            staffId: this.currentBaseInfo.id,
            signupRecordId: this.signupRecordId,
            signatureFile: data,
            welfareCategory:this.category
          }).then(res => {
            if (res.code == 200) {
              toast(this, res.message);
              this.loading = false;
              this.showSig = false;
              this.getActivityStaff();
            } else {
              toast(this, res.message, "error");
              this.loading = false;
            }
          });
        } else {
          unionBranchAdminSignature({
            activityId: this.activityDeailStaff.activityId,
            unionId: this.currentBaseInfo.unionId,
            staffId: this.currentBaseInfo.id,
            signatureFile: data,
            welfareCategory:this.category
          }).then(res => {
            if (res.code == 200) {
              toast(this, res.message);
              this.loading = false;
              this.showSig = false;
              this.getActivityUnion();
            } else {
              toast(this, res.message, "error");
              this.loading = false;
            }
          });
        }
      }
    },

    back() {
      setTimeout(() => {
        this.$router.go(-1);
      }, 1000);
    },
    openWinners(item) {
      if (item.openText == "展开") {
        item.openText = "收起";
        item.awardsTempId = 2;
      } else {
        item.openText = "展开";
        item.awardsTempId = 1;
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if(this.category=='0'){
      if (to.name === "welfare") {
        next({ name: "home", query: { label: "节日慰问领取" } });
      } else {
        next();
      }
    }else{
       if (to.name === "greetings") {
        next({ name: "home", query: { label: "生日慰问领取" } });
      } else {
        next();
      }
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
.sino-detail-footer {
  display: none;
}

.activity-detail {
  height: calc(100% - 44px);
  background: #fff;
  overflow: auto;

  .sino-welfare-title {
    height: 50px;
    line-height: 50px;
    padding: 0 10px;
    font-size: 22px;
    font-weight: 700;
    color: rgba(53, 53, 53, 1);
    white-space: nowrap;
    display: inline-block;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    box-sizing: border-box;
  }

  .sino-welfare-content {
    max-height: calc(100% - 255px);

    // overflow:auto;
    .html {
      color: #888;
      margin-bottom: 10px;
      line-height: 28px;
      padding: 0 10px;
      font-size: 14px;
      color: rgba(136, 136, 136, 1);
    }

    .sino-fold-btn {
      margin-right: 10px;
      color: rgba(56, 199, 196, 1);
      position: relative;
      text-align: right;
      display: block;
      font-size: 14px;
    }
  }

  .sino-activity-footer {
    text-align: center;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    margin: 10px 0;
    background: #FFF;

    .save-btn {
      width: 190px;
      height: 52px;
      line-height: 52px;
      display: inline-block;
      text-align: center;
      background: linear-gradient(0deg, rgba(12, 212, 183, 1), rgba(61, 212, 243, 1));
      border-radius: 52px;
      font-size: 20px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      border-radius: 26px;
    }

    .save-btn-disabled {
      width: 190px;
      height: 52px;
      line-height: 52px;
      display: inline-block;
      text-align: center;
      background: linear-gradient(0deg, rgba(61, 212, 243, 0.5), rgba(12, 212, 183, 0.5));
      border-radius: 52px;
      font-size: 20px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
    }

    .sign {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .img-block {
        width: 290px;
        height: 74px;
        background: rgba(243, 245, 248, 1);
        border-radius: 2px;
        position: relative;
        margin: 10px 0;

        .sign-img {
          width: 70px;
          position: absolute;
          top: 18%;
          left: 50%;
          transform: rotate(90deg) translate(-26%, 35%);
        }
      }
    }
  }
}

.sino-prize {
  margin-top: 20px;

  .prize-lev {
    font-size: 18px;
    margin: 20px 0;
    text-align: center;
    color: rgba(53, 53, 53, 1);
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 28px;

    .prize-name {
      color: rgba(56, 199, 196, 1);
      margin-left: 10px;
    }

    .check-btn {
      display: inline-block;
      margin-left: 20px;
      font-size: 14px;
      color: #888;
    }
  }

  .prize-th {
    text-align: center;
  }

  .winners {
    min-height: 40px;
    display: flex;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(136, 136, 136, 1);
    background: #f3f5f8;
    line-height: 28px;
    padding: 5px 20px;
  }
}

.prize-lev-flex {
  display: flex;
  justify-content: center;
  font-size: 15px !important;
}

.text-max-width {
  max-width: 245px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 16px;
}

.sino-prize-my {
  >div {
    display: flex;
    justify-content: center;
  }

  >div:nth-child(1) {
    font-size: 16px;
    margin-bottom: 16px;
  }

  >div:nth-child(2) {
    font-family: PingFang SC;
    font-weight: bold;
    font-size: 24px;

    span {
      color: #FF858B;
      max-width: 245px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-left: 4px;
    }
  }
}
</style>